import apiSportsObjects from '@/api/sports-objects'

const state = {
  isLoading: false,
  sportsObject: null,
  validationErrors: null,
  isSubmitting: false
}

export const mutationTypes = {
  updateSportObjectsStart: '[update sportsObjects] updateSportObjectsStart',
  updateSportObjectsSuccess: '[update sportsObjects] updateSportObjectsSuccess',
  updateSportObjectsFailure: '[update sportsObjects] updateSportObjectsFailure',

  getSportObjectsStart: '[update sportsObjects] getSportObjectsStart',
  getSportObjectsSuccess: '[update sportsObjects] getSportObjectsSuccess',
  getSportObjectsFailure: '[update sportsObjects] getSportObjectsFailure'
}

export const actionType = {
  updateSportObjects: '[update sportsObjects] updateSportObjects',
  getSportObjects: '[update sportsObjects] getSportObjects'
}

const mutations = {
  [mutationTypes.updateSportObjectsStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
    state.sportsObject = null
  },

  [mutationTypes.updateSportObjectsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateSportObjectsFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },

  [mutationTypes.getSportObjectsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportObjectsSuccess](state, payload) {
    state.isLoading = false
    state.sportsObject = payload
  },

  [mutationTypes.getSportObjectsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  }
}

const actions = {
  [actionType.getSportObjects](context, {id}) {
    context.commit(mutationTypes.getSportObjectsStart)
    return new Promise(resolve => {
      apiSportsObjects
        .getSportObject(id)
        .then(response => {
          context.commit(mutationTypes.getSportObjectsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.getSportObjectsFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.updateSportObjects](context, sport) {
    context.commit(mutationTypes.updateSportObjectsStart)
    return new Promise(resolve => {
      apiSportsObjects
        .updateSportObjects(sport)
        .then(response => {
          context.commit(mutationTypes.updateSportObjectsSuccess, response.data)
          resolve(response.data)
        })
        .catch(result => {
          context.commit(
            mutationTypes.updateSportObjectsFailure,
            result.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
